export const serializeNestedQueryParams = (params: any): string => {
  const queryParts: string[] = [];

  function buildQuery(obj: any, currentKey: string) {
    if (obj === null || obj === undefined) return;

    if (typeof obj === "object" && !Array.isArray(obj)) {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const newKey = currentKey ? `${currentKey}[${key}]` : key;
          buildQuery(obj[key], newKey);
        }
      }
    } else if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        const newKey = `${currentKey}[${index}]`;
        buildQuery(item, newKey);
      });
    } else {
      queryParts.push(
        `${encodeURIComponent(currentKey)}=${encodeURIComponent(obj)}`
      );
    }
  }

  buildQuery(params, "");
  return queryParts.join("&");
};
